import BaseMessageHandler from '../BaseMessageHandler';
import { closeModal } from 'actions/modal';
import Token from 'helpers/Token';
import { createAction } from 'helpers/redux';
import LocalStorage from 'helpers/LocalStorage';
import getStringWithSpecialSymbols from 'helpers/getStringWithSpecialSymbols';
import ACTIONS from 'constants/actionTypes';

export default class Auth_Login extends BaseMessageHandler {
  success = () => {
    const { dispatch, message, history, response } = this;
    const { payload } = message;

    const name = getStringWithSpecialSymbols(message.payload.user.name);

    dispatch(closeModal());
    dispatch(
      createAction({
        type: ACTIONS.LOGIN_USER,
        payload: {
          user: {
            ...payload.user,
            name,
            jwt: payload.jwt,
          },
        },
      })
    );
    LocalStorage.remove('nextPing');
    Token.setTokens({ authToken: response.data.authToken });

    const { state } = history.location;

    if (
      state?.returnUrl &&
      state.returnUrl !== '/login' &&
      state.returnUrl !== '/login-as-support'
    ) {
      history.push(state.returnUrl);
    } else {
      history.push('/');
    }
  };

  validation = () => {
    const { dispatch, message } = this;
    const { payload } = message;

    dispatch(
      createAction({
        type: ACTIONS.SET_USER_ERROR,
        payload,
      })
    );
  };
}
